import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './en.json';
import translationNL from './nl.json';
import translationDE from './de.json';

// Translation resources
const resources = {
  en: { translation: translationEN },
  nl: { translation: translationNL },
  de: { translation: translationDE },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en", // Default language
    detection: {
      // order: ['localStorage', 'navigator'], // Check localStorage first
      order: ['navigator', 'localStorage'],
      caches: ['localStorage'], // Save language in localStorage
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
